<template>
  <div class="user">
    <ul class="clearfix">
      <li class="user-li">
        <a href="javascript:" @click="toggleDrawerNotice"
           class="user-link user-btnonly">
<!--          <el-badge v-if="unreadNoticeNum > 0" class="user-btnico-badge" :value="unreadNoticeNum">-->
<!--            <span class="mng icon-bell-stroke"></span>-->
<!--          </el-badge>-->
          <i class="mng icon-bell-stroke">
            <span v-if="unreadNoticeNum > 0" class="red-dot"></span>
          </i>
        </a>
      </li>
      <li class="user-li">
        <el-dropdown @command="handleUserCommand">
          <a href="javascript:;" class="el-dropdown-link user-link user-account">
            <div class="user-portrait"><img src="/static/styles/images/port.png" alt=""></div>
            <span class="user-name">{{ getUserName }}</span>
            <span class="user-arrow"><i class="mng icon-arrow-down-fill"></i></span>
          </a>
          <el-dropdown-menu slot="dropdown" class="user-drop">
            <el-dropdown-item class="drop-list">
              <i class="mng icon-personal-stroke"></i>
              <span class="drop-txt">个人资料</span>
            </el-dropdown-item>
            <el-dropdown-item class="drop-list" command="updatePassword">
              <i class="mng icon-freeze-stroke1"></i>
              <span class="drop-txt">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item class="drop-list" command="changeTheme">
              <i class="mng icon-theme"></i>
              <span class="drop-txt">更换皮肤</span>
            </el-dropdown-item>
            <el-dropdown-item class="drop-list"  command="loginOut" >
              <i class="mng icon-exit-stroke2"></i>
              <span class="drop-txt">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <theme-switch ref="themeSwitch" @theme-change-success="handleThemeChangeSuccess" width="40%"></theme-switch>
    <drawer-notice ref="drawerNotice" @unread-notice-num-change="handleUnreadNoticeNumChange"></drawer-notice>
  </div>
</template>
<script>
  import util from '@/libs/util.js'
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  // import {STORE_PERMISSION_MUTATION_TYPES} from '../../libs/constants'
  // import {STORE_USER_MUTATION_TYPES} from '../../libs/constants'
  import ThemeSwitch from '../theme-switch/theme-switch.vue'
  import DrawerNotice from '../drawer-notice/drawer-notice'
  export default {
    components: {
      DrawerNotice,
      ThemeSwitch
    },
    name: 'top-user',
    data () {
      return {
        currentUser: {},
        themeFormConfig: {
          fields: []
        },
        unreadNoticeNum: 0
      }
    },
    created() {
      this.initUserInfo()
    },
    computed: {
      getUserName: function () {
        if (this.currentUser) {
          if (this.currentUser.trueName) {
            return this.currentUser.trueName
          }
          return this.currentUser.loginId
        }
        return '游客'
      },
      userBtnIconStyle: function () {
        return {
          opacity: this.unreadNoticeNum > 0 ? 1 : 0.6
        }
      }
    },
    methods: {
      handleUserCommand (command) {
        if (command === 'loginOut') {
          // 退出登录
          util.logout()
          // this.$store.commit(STORE_APP_MUTATION_TYPES.RESET_APP_STATE)
          // this.$store.commit(STORE_PERMISSION_MUTATION_TYPES.RESET_PERMISSION_STATE)
          // this.$store.commit(STORE_USER_MUTATION_TYPES.RESET_USER_STATE)
          // this.$router.push({name: 'login'})
          // window.location.reload()
        } else if (command === 'updatePassword') {
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, {id: 'updatePassword', name: '修改密码'})
          this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, {id: 'updatePassword'})
          this.$router.push({name: 'updatePassword'})
        } else if (command === 'changeTheme') {
          this.$refs.themeSwitch.show()
        }
      },
      initUserInfo () {
        this.$store.dispatch('GetUserInfo').then(userInfo => { // 拉取用户信息
          this.currentUser = userInfo
        }).catch((e) => {
          console.error(e)
          this.$notify.error({title: '错误', message: '用户名获取失败！'})
        })
      },
      handleThemeChangeSuccess () {
        this.$refs.themeSwitch.hide()
      },
      toggleDrawerNotice() {
        this.$refs.drawerNotice.toggle()
      },
      handleUnreadNoticeNumChange(newVal) {
        this.unreadNoticeNum = newVal
      }
    }
  }
</script>
<style lang="scss">
.user-drop {
  .drop-list:hover{
    background-color: #f3f5f7;
    color: #616365;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top-user/top-user.vue